import { defineStore } from 'pinia'

import type { OAuthStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useOAuthStore = defineStore('oauth', {
  state: (): OAuthStore => ({
    loading: false,
    google: [],
    zoho: null,
  }),
  actions,
  getters,
})
